import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

import './MetricToggle.scss';

/**
 * Two-values toggle (left/right) for metric selectors.
 * Controlled component.
 */
const MetricToggle = ({
    leftLabel,
    rightLabel,
    isRightSelected,
    onToggle,
    disabled,
    dockBottomRight,
}) => {
    const inner = (
        <>
            <span className="MetricToggle__label text-nowrap">{leftLabel}</span>
            <span className="MetricToggle__switch">
                <Checkbox
                    toggle
                    checked={!!isRightSelected}
                    onChange={(_e, d) => onToggle?.(!!d.checked)}
                    disabled={disabled}
                />
            </span>
            <span className="MetricToggle__label text-nowrap">{rightLabel}</span>
        </>
    );

    if (dockBottomRight) {
        return (
            <div className="MetricToggle__dock">
                <div className="MetricToggle">{inner}</div>
            </div>
        );
    }

    return <div className="MetricToggle">{inner}</div>;
};

MetricToggle.propTypes = {
    leftLabel: PropTypes.node,
    rightLabel: PropTypes.node,
    isRightSelected: PropTypes.bool,
    onToggle: PropTypes.func,
    disabled: PropTypes.bool,
    /** Fixed bottom-right (analysis screens). */
    dockBottomRight: PropTypes.bool,
};

export default MetricToggle;

